import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";

import ErrorIcon from "./../../assets/img/error.svg";
import { warning } from "./../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  errorStyles: {
    color: warning,
    [down("xs")]: {
      background: "rgb(216 141 0 / 10%)",
      borderRadius: "10px",
      padding: "10px",
    },
    "& span": {
      fontSize: "14px",
      fontFamily: "sbcBold",
    },
  },
}));

const Error = ({ errorMessage }) => {
  const { errorStyles } = useStyles();
  return (
    <Box display="flex" className={errorStyles} alignItems="center">
      <Box mr={1} display="flex" justifyContent="center" alignItems="center">
        <img src={ErrorIcon} alt="error" />
      </Box>
      <Typography variant="caption">{errorMessage}</Typography>
    </Box>
  );
};

export default Error;
